import React from "react";
import './sideprojects.css'
import { FiExternalLink } from "react-icons/fi";
import useReveal from "../../hooks/useReveal";

const projects = [
    {
        id: 1,
        name: "playroom",
        title: "PlayRoom",
        description: "Real-time multiplayer party game — play Charades and Scribble with friends in seconds. Room codes, a live shared drawing canvas, chat-based guessing and speed-based scoring, all over WebSockets.",
        stack: ["React", "Vite", "Socket.IO", "FastAPI"],
        link: "https://playroom.skdev.one",
    },
    {
        id: 2,
        name: "moneyflow",
        title: "MoneyFlow",
        description: "Personal-finance tracker that auto-imports transactions from Gmail alerts and bank / credit-card PDF statements across multiple Indian banks (HDFC, Axis, ICICI, Kotak…). Per-user Gmail OAuth, statement parsing, dedup, smart categorization and budgets.",
        stack: ["React", "FastAPI", "Gmail API", "Claude API"],
        link: "https://moneyflow.skdev.one",
    },
    {
        id: 3,
        name: "ai-trader",
        title: "AI Trading Agent",
        description: "Autonomous agent for Indian markets (NSE/BSE) running an observe → decide → act → learn loop. An LLM reasons over prices, news and portfolio to make paper trades, with risk controls and end-of-day reflections via the Anthropic Claude API.",
        stack: ["Python", "Next.js", "FastAPI", "Claude API"],
        link: "https://alphaagent.skdev.one",
    },
    {
        id: 4,
        name: "socialflow",
        title: "SocialFlow",
        description: "Practice and improve social skills through AI-driven conversations. Generates dynamic, context-aware scenarios and returns a personalized report card with feedback to track progress over time.",
        stack: ["React", "Material UI", "Deepseek LLM"],
        link: "https://socialflow.skdev.one",
    },
];

const SideProjects = () => {
    const ref = useReveal();
    return (
        <section id="side-projects">
            <h5>$ ls ~/side-projects</h5>
            <h2>Side Projects</h2>
            <div className="container sideprojects__container reveal" ref={ref}>
                {projects.map(({ id, name, title, description, stack, link }) => (
                    <article className="sideproject term-window" key={id}>
                        <div className="term-titlebar">
                            <span className="term-dot red"></span>
                            <span className="term-dot yellow"></span>
                            <span className="term-dot green"></span>
                            <span className="term-path">~/{name}</span>
                        </div>
                        <div className="sideproject__body">
                            <h3 className="mono">{title}</h3>
                            <p>{description}</p>
                            <div className="sideproject__actions">
                                <div className="sideproject__stack">
                                    {stack.map((s) => <span className="chip" key={s}>{s}</span>)}
                                </div>
                                <a className="sideproject__link mono" href={link} target="_blank" rel="noreferrer">
                                    $ open <FiExternalLink/>
                                </a>
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    )
}

export default SideProjects
